import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import { RequestDict } from '../../../components/dictionaries/RequestStatus';

export const registrations_columns: GridColDef[] = [
  {
    field: 'title',
    headerName: 'Τίτλος',
    minWidth: 350,
    renderCell: (params) => params.row.category === 'location'
      ? params.row.location_title
      : params.row.category === 'professionals'
        ? params.row.professional_title
        : params.row.filming_title
  },
  {
    field: 'category',
    headerName: 'Κατηγορία Καταχώρισης',
    flex: 1,
    minWidth: 120,
    renderCell: (params) => params.row.category === 'location'
      ? 'Τοποθεσία'
      : params.row.category === 'professionals'
        ? 'Επαγγελματίας'
        : 'Κράτηση Τοποθεσίας'
  },
  {
    field: 'submit_date',
    headerName: 'Ημερομηνία Προσθήκης',
    flex: 1,
    minWidth: 170,
    renderCell: (params) => params.row.category === 'location'
      ? params.row.location_date_created
        ? moment(params.row.location_date_created).format('DD/MM/YYYY').toLocaleString()
        : '-'
      : params.row.category === 'professionals'
        ? params.row.professional_date_created
          ? moment(params.row.professional_date_created).format('DD/MM/YYYY').toLocaleString()
          : '-'
        : moment(params.row.filming_date_created).format('DD/MM/YYYY').toLocaleString()
  },
  {
    field: 'date_deleted',
    headerName: 'Ημερομηνία Αφαίρεσης',
    flex: 1,
    minWidth: 170,
    renderCell: (params) => params.row.date_deleted
      ? moment(params.row.date_deleted).format('DD/MM/YYYY').toLocaleString()
      : '-'
  },
];

export const entry_exit_card_columns: GridColDef[] = [
  {
    field: 'login_date',
    headerName: 'Στοιχεία Εισόδου',
    minWidth: 200,
    sortable: false,
    renderCell: (params) => params.row.login_date
      ? moment(params.row.login_date).format('DD/MM/YYYY, hh:mm:ss').toLocaleString()
      : '-'
  },
  {
    field: 'logout_date',
    headerName: 'Στοιχεία Εξόδου',
    flex: 1,
    minWidth: 200,
    sortable: false,
    renderCell: (params) => params.row.logout_date
      ? moment(params.row.logout_date).format('DD/MM/YYYY, hh:mm:ss').toLocaleString()
      : '-'
  },
  {
    field: 'navigation_time',
    headerName: 'Διάρκεια Περιήγησης',
    flex: 1,
    minWidth: 120,
    sortable: false
  },
  {
    field: 'country',
    headerName: 'Χώρα Προέλευσης',
    flex: 1,
    minWidth: 150,
  },
];

export const applications_columns: GridColDef[] = [
  {
    field: 'title',
    headerName: 'Τίτλος',
    minWidth: 350,
  },
  {
    field: 'category',
    headerName: 'Κατηγορία Αιτήματος',
    flex: 1,
    minWidth: 120,
    renderCell: (params) => params.row.category === 'location'
      ? 'Τοποθεσία'
      : params.row.category === 'professionals'
        ? 'Επαγγελματίας'
        : 'Κράτηση Τοποθεσίας'
  },
  {
    field: 'submit_date',
    headerName: 'Ημερομηνία Υποβολής',
    flex: 1,
    minWidth: 170,
    renderCell: (params) => params.row.submit_date
      ? moment(params.row.submit_date).format('DD/MM/YYYY').toLocaleString()
      : '-'
  },
  {
    field: 'status',
    headerName: 'Κατάσταση',
    minWidth: 200,
    renderCell: (params) => RequestDict[params.row.status]
  },
];
export const favourites_columns: GridColDef[] = [
  {
    field: 'title',
    headerName: 'Τίτλος',
    minWidth: 350,
    sortable: false
  },
  {
    field: 'category',
    headerName: 'Κατηγορία',
    flex: 1,
    minWidth: 120,
    sortable: true,
    renderCell: (params) => params.row.category === 'location'
      ? 'Τοποθεσία'
      : 'Επαγγελματίας'
  },
  {
    field: 'date_added',
    headerName: 'Ημερομηνία Προσθήκης',
    flex: 1,
    minWidth: 170,
    sortable: true,
    renderCell: (params) => params.row.date_added
      ? moment(params.row.date_added).format('DD/MM/YYYY, hh:mm:ss').toLocaleString()
      : '-'
  },
  {
    field: 'date_removed',
    headerName: 'Ημερομηνία Αφαίρεσης',
    flex: 1,
    minWidth: 170,
    sortable: true,
    renderCell: (params) => params.row.date_removed
      ? moment(params.row.date_removed).format('DD/MM/YYYY, hh:mm:ss').toLocaleString()
      : '-'
  },
];
export const search_audit_columns: GridColDef[] = [
  {
    field: 'category',
    headerName: 'Είδος Αναζήτησης',
    flex: 1,
    minWidth: 120,
    renderCell: (params) => params.row.category === 'location'
      ? 'Τοποθεσία'
      : 'Επαγγελματίας'
  },
  {
    field: 'totalCount',
    headerName: 'Αριθμός Αποτελεσμάτων',
    minWidth: 350,
  },
];

export const crmSearchHeaderTitles = [
  { title: 'Είδος Αναζήτησης', refValue: 'search_kind' },
  { title: 'Αριθμός Αποτελεσμάτων', refValue: 'total_results' },
];
export const crmSearchHeaderTitles_columns: GridColDef[] = [
  {
    field: 'search_kind',
    headerName: 'Είδος Αναζήτησης',
    flex: 1,
    minWidth: 350
  },
  {
    field: 'total_results',
    headerName: 'Αριθμός Αποτελεσμάτων',
    flex: 0.5,
    minWidth: 120
  }
];
export const crmSearchLocSubHeaderTitles = [
  { title: 'Ελεύθερο Κείμενο', refValue: 'free_text' },
  { title: 'Περιφέρειες/Δήμοι', refValue: 'regions' },
  { title: 'Θεματική Ενότητα', refValue: 'level1' },
  { title: 'Κατηγορία Τοποθεσίας', refValue: 'level2' }
];

export const crmSearchProfSubHeaderTitles = [
  { title: 'Ελεύθερο Κείμενο', refValue: 'free_text' },
  { title: 'Περιφέρειες/Δήμοι', refValue: 'regions' },
  { title: 'Κατηγορία Υπηρεσιών', refValue: 'level1' },
];
export const crmSearchCollectionsSubHeaderTitles = [
  { title: 'Τίτλος Συλλογής', refValue: 'collectionIds' },
  { title: 'Τίτλος Έργου', refValue: 'ergoTitle' },
  { title: 'Τύπος Έργου', refValue: 'ergoType' },
  { title: 'Εμπλεκόμενοι', refValue: 'suntelestisName' },
  { title: 'Τύπος Τεκμηρίου', refValue: 'tekmirioType' },
  { title: 'Λέξεις-Κλειδιά', refValue: 'keywords' },
  { title: 'Έτος Από', refValue: 'fromDate' },
  { title: 'Έτος Έως', refValue: 'toDate' },
];
export const crmSearchMediaSubHeaderTitles = [
  { title: 'Ονομασία Φορέα', refValue: 'foreasName' },
  { title: 'Τίτλος Συλλογής', refValue: 'collectionIds' },
  { title: 'Τίτλος Έργου', refValue: 'ergoTitle' },
  { title: 'Τύπος Έργου', refValue: 'ergoType' },
  { title: 'Τύπος Τεκμηρίου', refValue: 'tekmirioType' },
  { title: 'Λέξεις-Κλειδιά', refValue: 'keywords' },
  { title: 'Έτος Από', refValue: 'fromDate' },
  { title: 'Έτος Έως', refValue: 'toDate' },
  { title: 'Εμπλεκόμενοι', refValue: 'suntelestisName' },
];
export const crmSearchForeisSubHeaderTitles = [
  { title: 'Ονομασία Φορέα', refValue: 'foreas' },
  { title: 'Περιγραφή Συλλογών', refValue: 'description' },
];

export const notes_columns: GridColDef[] = [
  {
    field: 'note',
    headerName: 'Σημείωση',
    flex: 1,
    minWidth: 250,
    sortable: false
  },
  {
    field: 'date_note',
    headerName: 'Ημερομηνία Σημείωσης',
    flex: 0.3,
    minWidth: 150,
    sortable: true,
    renderCell: (params) => params.row.date_note
      ? moment(params.row.date_note).format('DD/MM/YYYY').toLocaleString()
      : '-'
  },
];

export const communication_columns: GridColDef[] = [
  {
    field: 'subject',
    headerName: 'Θέμα',
    flex: 1,
    minWidth: 250,
    sortable: false
  },
  {
    field: 'category',
    headerName: 'Κατηγορία',
    flex: 0.5,
    minWidth: 150,
    sortable: true
  },
  {
    field: 'created_by',
    headerName: 'Καταγραφή Από',
    flex: 0.8,
    minWidth: 250,
    sortable: true
  },
  {
    field: 'date',
    headerName: 'Ημερομηνία Τηλεφωνικής Επικοινωνίας',
    flex: 0.5,
    minWidth: 150,
    sortable: true,
    renderCell: (params) => params.row.date
      ? moment(params.row.date).format('DD/MM/YYYY, hh:mm').toLocaleString()
      : '-'
  },
];
export const newsletter_columns: GridColDef[] = [
  {
    field: 'title',
    headerName: 'Τίτλος',
    minWidth: 350,
  },
  {
    field: 'category',
    headerName: 'Κατηγορία Newsletter',
    flex: 1,
    minWidth: 120,
  },
  {
    field: 'subscription_date',
    headerName: 'Ημ. Εγγραφής',
    flex: 1,
    minWidth: 170,
    renderCell: (params) => params.row.subscription_date
      ? moment(params.row.subscription_date).format('DD/MM/YYYY').toLocaleString()
      : '-'
  },
  {
    field: 'unsubscribe_date',
    headerName: 'Ημ. Απεγγραφής',
    minWidth: 200,
    renderCell: (params) => params.row.unsubscribe_date
      ? moment(params.row.unsubscribe_date).format('DD/MM/YYYY').toLocaleString()
      : '-'
  },
];
export const newsletter_categories_columns: GridColDef[] = [
  {
    field: 'category',
    headerName: 'Κατηγορία Newsletter',
    flex: 1
  },
  {
    field: 'incoming_count',
    headerName: 'Αριθμός Λήψεων',
    flex: 0.5
  },
];
export const zoom_columns: GridColDef[] = [
  {
    field: 'title',
    headerName: 'Τίτλος',
    flex: 1
  },
  {
    field: 'start_time',
    headerName: 'Ημ. Διεξαγωγής',
    flex: 1,
    minWidth: 170,
    renderCell: (params) => params.row.start_time
      ? moment(params.row.start_time).format('DD/MM/YYYY').toLocaleString()
      : '-'
  },
  {
    field: 'duration',
    headerName: 'Διάρκεια (Σε λεπτά)',
    flex: 0.5
  },
];